import { LocalDateTime } from 'js-joda';
import { core, payloadToJSON } from '@tock/coretypes';
import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

export interface Export {
  id: string;
  type: dashboard.ExportType;
  status: core.WorkflowInfo.Status;
  createdAt: LocalDateTime;
  exports?: dashboard.IExport[];
}

interface ExportState {
  exports: { [k: string]: Export };
  isMarketingOptInExportLoading: boolean;
}

const initialState: ExportState = {
  exports: {},
  isMarketingOptInExportLoading: false,
};

export default function reducer(state = initialState, action: BaseTockAction): ExportState {
  const { type, payload } = action;

  switch (type) {
    case AppConstants.EXPORT_MARKETING_OPT_IN_CSV_STARTING: {
      return {
        ...state,
        isMarketingOptInExportLoading: true,
      };
    }
    case AppConstants.EXPORT_MARKETING_OPT_IN_CSV_FAILED: {
      return {
        ...state,
        isMarketingOptInExportLoading: false,
      };
    }
    case AppConstants.EXPORT_MARKETING_OPT_IN_CSV_DONE: {
      const workflowInfo = payloadToJSON<core.WorkflowInfo>(payload);
      return {
        ...state,
        exports: {
          ...state.exports,
          [workflowInfo.runId]: {
            ...state.exports[workflowInfo.runId],
            id: workflowInfo.runId,
            status: workflowInfo.status,
            type: 'MARKETING_OPT_IN',
            createdAt: LocalDateTime.now(),
          },
        },
      };
    }
    case AppConstants.EXPORT_MARKETING_OPT_IN_CSV_WORKFLOW_STATUS_DONE: {
      const workflowInfo = payloadToJSON<core.WorkflowInfo>(payload);
      return {
        ...state,
        exports: {
          ...state.exports,
          [workflowInfo.runId]: {
            ...state.exports[workflowInfo.runId],
            status: workflowInfo.status,
          },
        },
      };
    }
    case AppConstants.EXPORT_MARKETING_OPT_IN_CSV_WORKFLOW_RESULTS_DONE: {
      const exportResults = payloadToJSON<dashboard.ExportResults>(payload);
      return {
        ...state,
        exports: {
          ...state.exports,
          [exportResults.id]: {
            ...state.exports[exportResults.id],
            status: 'COMPLETED',
            exports: exportResults.exports,
          },
        },
        isMarketingOptInExportLoading: false,
      };
    }
    case AppConstants.EXPORT_DISMISS: {
      const id = payload as string;
      const updatedExports = { ...state.exports };
      delete updatedExports[id];
      return {
        ...state,
        exports: {
          ...updatedExports,
        },
      };
    }
    default:
      return state;
  }
}
